<div class="wrapper">
  <div class="container-my">
    <div class="screen">
      <span class="title">
        Log in as Merchant
      </span>
      <div class="screen__content" *ngIf="loginForm">
        <form class="login" [formGroup]="loginForm">
          <p class="error" *ngIf="!loginIsValid">Wrong details, please check</p>
          <div class="login__field">
            <!-- <i class="login__icon fas fa-user"></i> -->
            <input type="text" class="login__input" placeholder="Username" formControlName="userName">
          </div>
          <div class="login__field">
            <!-- <i class="login__icon fas fa-lock"></i> -->
            <input type="password" class="login__input" placeholder="Password" formControlName="password">
          </div>
          <button class="button login__submit" (click)="loginBtn()">
            <span class="button__text">Log In</span>
            <i class="button__icon fas fa-chevron-right"></i>
          </button>
        </form>
        <div class="social-login">
          <h3>Log in as</h3>
          <div class="social-icons">
            <a class="pxuser" routerLink="/payx-login">Payx User</a>
          </div>
        </div>
      </div>
      <div class="screen__background">
        <span class="screen__background__shape screen__background__shape4"></span>
        <span class="screen__background__shape screen__background__shape3"></span>
        <span class="screen__background__shape screen__background__shape2"></span>
        <span class="screen__background__shape screen__background__shape1"></span>
      </div>
    </div>
  </div>
</div>
